import React from "react";
import { alpha, styled } from '@mui/material/styles';
import {
    Box,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select
} from '@mui/material';

const CustomInputLabel = styled(InputLabel)({
    '&.MuiInputLabel-formControl': {
        color: 'rgba(178, 235, 177, 1)',
    },
    '&.Mui-focused': {
          color: 'rgba(178, 235, 177, 1)',
    },
    '&.Mui-disabled': {
          color: 'rgba(139, 180, 146, 1)',
    },
})

const CustomSelect = styled(Select)({
    color: 'rgb(255, 255, 255)',
    '.MuiOutlinedInput-notchedOutline': {
        border: '1px solid rgba(139, 142, 146, 1)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(178, 235, 177, 1)',
        borderWidth: 1,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.7)',
        borderWidth: 1
    },
    '.MuiSvgIcon-root': {
        fill: 'white'
    },
    '&.Mui-focused .MuiSvgIcon-root': {
        fill: 'rgba(178, 235, 177, 1)',
    },
    '&.Mui-disabled .MuiSvgIcon-root': {
        fill: 'rgba(175, 175, 175, 1)',
    },
    '&.Mui-disabled .MuiSelect-select': {
        color: 'rgba(175, 175, 175, 1)',
        WebkitTextFillColor: 'rgba(175, 175, 175, 1)', // For Chrome/Safari
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(139, 142, 146, 1)',
        borderWidth: 1,
    },
})

const CustomMenuItem = styled(MenuItem)({
    '&.MuiMenuItem-root': {
        backgroundColor: 'rgba(28, 28, 28, 1)',
        color: 'rgba(255, 255, 255, 1)',
    },
    '&.MuiMenuItem-root.Mui-selected': {
        backgroundColor: 'rgba(55, 58, 65, 1)',
        color: 'rgba(255, 255, 255, 1)'
    },
    '&.MuiMenuItem-root:hover': {
        backgroundColor: 'rgba(55, 58, 65, 1)',
        color: 'rgba(255, 255, 255, 1)'
    },
    '&.MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: 'rgba(55, 58, 65, 1)',
        color: 'rgba(255, 255, 255, 1)'
    },
})

const CustomChip = styled(Chip)({
    '&.MuiChip-outlined': {
        border: '1px solid rgba(178, 235, 177, 0.5)',
        color: 'rgba(255, 255, 255, 1)'
    },
    '&.Mui-disabled': {
        opacity: 1,
    },
    "& .MuiChip-label": {
        color: "rgb(255, 255, 255)",
    },
    '&.Mui-disabled .MuiChip-label': {
        color: 'rgba(255, 175, 175, 1)', // For Chrome/Safari
    },
})

export default function ExpandedDropDown(props) {
    const { label, options, dense=true, value, onChange, multiple=false, fullWidth='250px', disabled=false } = props

    return (
        <Box
            display="flex"
            alignContent="flex-start"
            flexDirection="column"
            flexWrap="wrap"
            width="auto"
            my={2}
        >
            <Box width={fullWidth}>
                <FormControl fullWidth={fullWidth}>
                    <CustomInputLabel>
                        {label}
                    </CustomInputLabel>
                    <CustomSelect
                        disabled={disabled}
                        value={value}
                        multiple={multiple}
                        onChange={onChange}
                        input={<OutlinedInput label={label} />}
                        renderValue={
                            multiple
                            ?
                            (selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value, index) => {
                                    return (
                                        <CustomChip
                                            disabled={disabled}
                                            variant="outlined"
                                            key={index}
                                            label={options.find(
                                                item => item.value === value
                                                )?.name
                                            }
                                        />
                                    )
                                    }
                                    )}
                                </Box>
                            )
                            :
                            undefined
                        }
                    >
                        {options.map((item, index) => (
                            <CustomMenuItem
                                dense={dense}
                                key={index}
                                value={item?.value || item?.name}
                            >
                                {item.name}
                            </CustomMenuItem>
                        ))}
                    </CustomSelect>
                </FormControl>
            </Box>
        </Box>
  );
}